import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

export default function PremiumGate({ children, entitlementState, checkoutUrl, message }) {
  const [config, setConfig] = useState({ url: checkoutUrl || "" });
  useEffect(() => {
    if (!checkoutUrl) {
      import("@/lib/api").then(({ default: api }) => {
        api.get("/config/public").then(({ data }) => setConfig({ url: data?.eduzz_checkout_url || "" })).catch(() => {});
      });
    }
  }, [checkoutUrl]);

  return (
    <div className="max-w-3xl mx-auto px-4 py-16 text-center" data-testid="premium-gate">
      <div className="text-6xl">🔒</div>
      <h1 className="mt-4 text-2xl sm:text-3xl font-extrabold text-[#243B53]">
        Conteúdo Premium do Clubinho
      </h1>
      <p className="mt-3 text-[#243B53]/75">
        {message || "Este conteúdo faz parte da assinatura Clubinho da Fé. Assine para desbloquear tudo com sua família."}
      </p>
      {entitlementState === "pending_review" && (
        <div className="mt-4 chip chip-sun">Sua assinatura está em revisão 💛</div>
      )}
      {(entitlementState === "revoked" || entitlementState === "expired") && (
        <div className="mt-4 chip">Assinatura expirou. Reative pelo checkout.</div>
      )}
      <div className="mt-8">
        {config.url ? (
          <a href={config.url} target="_blank" rel="noopener noreferrer"
             data-testid="premium-gate-cta"
             className="btn-primary inline-block">
            Quero fazer parte — R$29,90/mês
          </a>
        ) : (
          <span className="text-sm text-[#243B53]/60">Em breve o link de assinatura.</span>
        )}
      </div>
    </div>
  );
}
